import { forwardRef, useState } from "react";
import Radio from "@mui/material/Radio";
import styles from "./MainQuestion.module.css";
import { Button } from "@mui/material";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import { translate } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const MainQuestion = forwardRef(
  (
    {
      is_completed,
      question,
      currentQuestion,
      handleQuestion,
      questionsCount,
      myAnswer,
      questionIndex,
      handleForwarded,
      forwarded,
      userQuestion,
    },
    ref,
  ) => {
    const nextQuestionHandler = (id, questionIndex,weight) => {
        handleQuestion(question, id, questionIndex,weight);
   
    };
    const { isAuth } = useSelector((state) => state.user);
    const { t } = useTranslation();

    const removeUser = () => {
      handleForwarded(forwarded.filter((el) => el.idQuestion == !question?.id));
    };


    const [open, setOpen] = useState(false);
    const [idQuestion, setIdQuestion] = useState("");
    const [title, setTitle] = useState("");
    const [titleFr, setTitleFr] = useState("");


    const handleForwardQuestion = () => {
      setOpen(true);
      setIdQuestion(question?.id);
      setTitle(question?.title);
      setTitleFr(question?.title_fr);
    };

    const handleClose = () => {
      setOpen(false);
    };
    return (
      <div className={styles.container} ref={ref}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className={styles.question_number} style={{ fontSize: "27px" }}>
            QUESTION {questionIndex + 1}
          </span>
        </div>
        <h4 style={{ padding: "20px 0px" }}>
          {question[translate("title")] || t("not_specified")}{" "}
        </h4>
        {question.choices.map((option) => (
          <p
            key={option.id}
            className={`${styles.options}
         ${myAnswer?.choice === option.id ? styles.selected : null}
         `}
            onClick={(e) => nextQuestionHandler(option.id, questionIndex,option.weight)}
          >
            <Radio
              checked={myAnswer?.choice === option.id}
              checkedIcon={
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                    fill="white"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 12L11 14L15 10"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
            />
            {option[translate("title")] || t("not_specified")}
          </p>
        ))}
        {questionIndex !== questionsCount - 1 && (
          <>
            <br />
            <hr></hr>
          </>
        )}
      </div>
    );
  }
);

export default MainQuestion;
